/**
 * Тип статьи
 * Портировано из backend/articles/proto/entities/articles.entities.proto
 *
 * String-значения соответствуют именам enum'а в proto и тому, что отдаёт
 * backend в JSONPb-формате (после DEV-182). gRPC-gateway URL-query parser
 * принимает как имя ("ARTICLE_TYPE_NEWS"), так и число — поэтому фильтр
 * filter.type в запросах продолжает работать без отдельного маппинга.
 */
export enum ArticleType {
  INVALID = 'ARTICLE_TYPE_INVALID',
  NEWS = 'ARTICLE_TYPE_NEWS',
  HANDBOOK = 'ARTICLE_TYPE_HANDBOOK',
  SERVICES = 'ARTICLE_TYPE_SERVICES',
  RESEARCH_AND_ANALYTICS = 'ARTICLE_TYPE_RESEARCH_AND_ANALYTICS',
  BUY_GUIDE = 'ARTICLE_TYPE_BUY_GUIDE',
  INVESTMENT = 'ARTICLE_TYPE_INVESTMENT',
  SEO_LANDING = 'ARTICLE_TYPE_SEO_LANDING',
  LOCATION = 'ARTICLE_TYPE_LOCATION',
}

export const ArticleTypeDisplayNames: Record<ArticleType, string> = {
  [ArticleType.INVALID]: 'Неизвестно',
  [ArticleType.NEWS]: 'Новости',
  [ArticleType.HANDBOOK]: 'Справочник',
  [ArticleType.SERVICES]: 'Услуги',
  [ArticleType.RESEARCH_AND_ANALYTICS]: 'Аналитика рынка',
  [ArticleType.BUY_GUIDE]: 'Покупка недвижимости во Вьетнаме',
  [ArticleType.INVESTMENT]: 'Инвестиции',
  [ArticleType.SEO_LANDING]: 'SEO-посадочная',
  [ArticleType.LOCATION]: 'Локация',
}
